/**
 * LED overlay router — picks the right LED theme based on the auction's
 * `led_theme` field. Default = "classic" (original red/orange LED).
 * "royal_gold" = premium navy & gold LED (Iter 39).
 *
 * Fetching the auction here (one lightweight request) means the overlay URL
 * `/overlay/:id/led` stays the single public link admins share — switching
 * themes in Settings instantly updates every open LED screen on next poll.
 */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { OverlayLED } from "./OverlayLED";
import { OverlayLEDRoyal } from "./OverlayLEDRoyal";

export function OverlayLEDRouter() {
  const { auctionId } = useParams();
  const [theme, setTheme] = useState(null);
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await api.get(`/public/auctions/${auctionId}`);
        if (!cancelled) setTheme(data?.auction?.led_theme === "royal_gold" ? "royal_gold" : "classic");
      } catch {
        if (!cancelled) setTheme("classic");
      }
    };
    load();
    // Re-check every 15s so a theme switch in Settings propagates to open
    // LED windows without needing a manual refresh.
    const id = setInterval(load, 15000);
    return () => { cancelled = true; clearInterval(id); };
  }, [auctionId]);
  if (theme === null) return <div style={{ minHeight: "100vh", background: "#030812" }} />;
  return theme === "royal_gold" ? <OverlayLEDRoyal /> : <OverlayLED />;
}
